import { useRouteLoaderData, useLocation, Outlet } from 'react-router-dom';

/**
 * ProtectedPageWrapper component ensures that the user is authorized to access the page.
 * It retrieves the session ID and unauthorized callback from the route loader data.
 * If the unauthorized callback is not provided, it throws an error.
 * If both the session ID and token are not available, it invokes the unauthorized callback with the current pathname.
 * Allowing `token` as authentication is needed for pre-login MFA flows where the user needs to add an MFA method before login.
 * Otherwise, it renders the Outlet component to display the child routes.
 *
 * @component
 * @returns {JSX.Element} The Outlet component if authorized, otherwise the result of unauthorizedCallback.
 */
const ProtectedPageWrapper = () => {
	const { ssId, unauthorizedCallback } = useRouteLoaderData('identity');
	const location = useLocation();
	const { token } = location.state || {};

	if (!unauthorizedCallback) {
		throw new Error('unauthorizedCallback is required');
	}
	if (!ssId && !token) {
		return unauthorizedCallback(location.pathname);
	}
	return <Outlet />;
};

export default ProtectedPageWrapper;
